import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TimestampFormatPipe } from '../../commons/timestampFormatPipe';
import { ComponentCacheService } from '../../services/component-cache.service';
import { CollaboratoreService } from '../../services/domain/collaboratore.service';
import { NavigatorService } from '../../services/navigator.service';
import { SondaggioService } from '../../services/sondaggio/sondaggio.service';
import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { SondaggioDTO } from '../../shared/dto/sondaggi/sondaggio';
import { GenericListComponent } from '../../shared/GenericListCoumponent';

@Component({
  selector: 'app-risposta-sondaggio',
  templateUrl: './risposta-sondaggio.component.html',
  styleUrls: ['./risposta-sondaggio.component.scss']
})

export class SondaggioRispostaComponent extends GenericListComponent implements OnInit, OnDestroy {

  collaboratori: CollaboratoreDTO[];
  sondaggi: SondaggioDTO[];
  collaboratore: CollaboratoreDTO;
  form: any;

  constructor(
    private sondaggioService: SondaggioService,
    private collaboratoreService: CollaboratoreService,
    componentCacheService: ComponentCacheService,
    navigatorService: NavigatorService,
    snackBar: MatSnackBar,
    dateAdapter: DateAdapter<Date>,
    router: Router,

    timestampFormatPipe: TimestampFormatPipe) {
    super(
      navigatorService,
      componentCacheService,
      dateAdapter,
      router,
      snackBar,
      timestampFormatPipe);

    this.displayedColumns = ['id', 'titolo', 'creatore', 'dataScadenza', 'giaRisposto', 'risposte', 'votanti', 'detail'];
    this.parameters = {
      dataSource: [],
      showList: false,
      filter: null,
      sortField: null,
      sortDirection: null,
      pageNumber: 0,
      pageSize: 50,
      length: 0,

      collaboratore: null,
      titolo: null,
      initDataScadenzaDa: true,
      dataScadenzaDa: null,
      dataScadenzaA: null,
      statoRispostaCollaboratore: null,
    }
  }

  list() {
    this.sondaggioService.sondaggioListPerRisposte(
      this.parameters.pageNumber,
      this.parameters.pageSize,
      this.parameters.sortDirection,
      this.parameters.sortField,

      this.parameters.titolo,
      this.parameters.collaboratore,
      this.parameters.dataScadenzaDa,
      this.parameters.dataScadenzaA,
      this.parameters.statoRispostaCollaboratore
    ).subscribe(
      (res: ResponseQueryByCriteria<SondaggioDTO>) => {
        console.log("response : ", res);
        this.parameters.dataSource = res.content;
        this.parameters.pageNumber = res.pageNumber;
        this.parameters.length = res.totalElements;
        this.parameters.showList = true;
      }
    );
  }

  ngOnInit() {
    super.ngOnInit();

    if(!this.isJappTenantAdmin()) {
      this.navigatorService.collaboratore.subscribe(
        (res: CollaboratoreDTO) => {
          this.parameters.collaboratore = res;
        }
      );
    }

    this.collaboratoreService.collaboratoreList(
      0,
      9999,
      'ASC',
      'nome',
      '').subscribe(
        (res: ResponseQueryByCriteria<CollaboratoreDTO>) => {
          console.log("response : " + res);
          this.collaboratori = res.content;
        }
      );

    if (this.parameters.dataScadenzaDa == null && this.parameters.initDataScadenzaDa) {
      this.parameters.dataScadenzaDa = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    }
  }

  numRisposte(s: SondaggioDTO): number {
    return s.risposte?.length ?? 0;
  }

  votanti(s: SondaggioDTO): number {
    return new Set(s.risposte?.map(r => r.collaboratore.id)).size;
  }

  giaRisposto(s: SondaggioDTO): string {
    const collId = this.parameters.collaboratore?.id;
    if(collId == null) {
      return '-';
    } else {
      let ret = false;
      s.risposte?.forEach(risposta => {
        if(!ret && risposta.collaboratore.id == collId){
          ret = true;
        }
      });
      return ret ? 'Sì' : 'No';
    }
  }

  isCollaboratoreSelected(): boolean {
    return this.parameters?.collaboratore != null;
  }

  onCollaboratoreSelectedChange(event: MatSelectChange): void {
    if(event.value == null) {
      this.parameters.statoRispostaCollaboratore = null;
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
